import { lazy } from 'react'

export const DashboardPage = lazy(() => import('@/pages/Dashboard'))
export const DigitalQRPage = lazy(() => import('@/pages/DigitalQR'))
export const GoogleAutomationPage = lazy(
  () => import('@/pages/GoogleAutomation'),
)
export const GoogleAuditPage = lazy(() => import('@/pages/GoogleAudit'))
export const GeneratePostsPage = lazy(() => import('@/pages/GeneratePosts'))
export const WebsitePage = lazy(() => import('@/pages/Website'))
export const PlansPage = lazy(() => import('@/pages/Plans'))
export const SettingsPage = lazy(() => import('@/pages/Settings'))
export const NotFoundPage = lazy(() => import('@/pages/NotFound'))

export const GmbAiAgentPage = lazy(() => import('@/pages/gmb/AiAgentPage'))
export const GmbOptimizationPage = lazy(
  () => import('@/pages/gmb/OptimizationPage'),
)
export const GmbReviewsPage = lazy(() => import('@/pages/gmb/ReviewsPage'))
export const GmbSchedulePage = lazy(() => import('@/pages/gmb/SchedulePage'))
export const GmbPostsPage = lazy(() => import('@/pages/gmb/PostsPage'))
export const GmbCreatePostPage = lazy(
  () => import('@/pages/gmb/CreatePostPage'),
)
export const GmbMediaPage = lazy(() => import('@/pages/gmb/MediaPage'))
export const GmbKeywordsPage = lazy(() => import('@/pages/gmb/KeywordsPage'))
export const GmbPerformancePage = lazy(
  () => import('@/pages/gmb/PerformancePage'),
)
export const GmbAiListingPage = lazy(() => import('@/pages/gmb/AiListingPage'))
